var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "verify",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27755",
    "data-name": "Path 27755",
    d: "M15.455,21.819a1.091,1.091,0,0,1-.775-.316l-4.364-4.364a1.1,1.1,0,0,1,1.549-1.549l3.589,3.6,6.862-6.873a1.1,1.1,0,0,1,1.549,1.549L16.23,21.5A1.091,1.091,0,0,1,15.455,21.819Z",
    transform: "translate(-2.56 -2.375)",
    fill: "#6cd098"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27756",
    "data-name": "Path 27756",
    d: "M17,31A14,14,0,1,1,31,17,14,14,0,0,1,17,31ZM17,5.154A11.846,11.846,0,1,0,28.846,17,11.846,11.846,0,0,0,17,5.154Z",
    transform: "translate(-3 -3)",
    fill: "#6cd098"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.b1a570d9f302483e8c91fed034def8ec.svg";
export { ForwardRef as ReactComponent };